export default "__VITE_ASSET__c05fbf20__"